import SideNav from "./sidenav";
import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Download from "../images/downloadicon.png";
import Check from "../images/check.png";
import "./privacy.css";

const Privacy = () => {
  const [active, setActive] = useState("Data Privacy Policy");

  function switchPrivacy(e) {
    let value = e.target.value;
    // alert(value)
    setActive(value);
  }

  const menuItems = ["Data Privacy Policy", "Terms & Conditions"];

    window.scrollTo(0, 0);

  return (
    <>
      <div
        id="privacy-types-section"
        class="containeer d-flex align-items-start   mt-4"
        style={{ backgroundColor: "none" }}
      >
        <SideNav
          style={{
            width: "50% !important",
          }}
          items={menuItems}
          activeItem={active}
          onSelect={setActive}
          types={false}
        />

        <div className="flex-1 p-6 full-width">
          <h6 className="dark-history pt-3 pb-3  d-block d-md-none">Filter</h6>
          <select
            className="form-select fund-select  d-block d-md-none"
            aria-label="Default select example"
            onChange={switchPrivacy}
          >
            <option value="Data Privacy Policy" selected>
              {" "}
              Data Privacy Policy{" "}
            </option>
            <option value="Terms & Conditions"> Terms & Conditions </option>
          </select>
          {active === "Data Privacy Policy" && (
            <div className="privacy-type-content">
              <h2 className="privacy-h2 ">Data Privacy Policy</h2>
              <hr className="btm-bdr-rma mt-5 pb-5" />

              <h4 className="card-subtitle mb-2 privacy-hdr">PREMABLE</h4>

              <p className="grey-p-privacy">
                Leadway PFA Limited (LPPFA) is dedicated to ensuring
                that the privacy and personal information of its esteemed
                Customers and employees (data subjects) are protected. LPPFA is
                a body that collects and processes personal information and this
                responsibility may be outsourced to third party (ies). LPPFA is
                also committed to complying with extant Nigerian and applicable
                international laws on data protection. For the purpose of this
                Data Privacy Policy, references to “LPPFA” or “the Company”
                shall mean Leadway PFA Ltd. By providing the data
                subject’s personal information or the personal information of a
                beneficiary through the enrolment form, online or any other
                means authorized and deployed by LPPFA, the data subject
                acknowledges that Leadway may only use the information in the
                manner specified in this Data Privacy Policy. There may be a
                need to update this policy periodically, for example as a result
                of regulatory dictate, new technologies or other developments on
                data protection and / or privacy laws. This current version of
                this policy is available on our website
                (www.leadway-pensure.com) and Leadway PFA’s mobile app.
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                ROLE DEFINITION
              </h4>

              <p className="grey-p-privacy">
                The following roles are defined for the purpose of this policy:
                <ul className="grey-p-privacy">
                  <li>
                    Data Subject: is any person who can be identified directly
                    or indirectly by an attribute such as name, ID, (e.g.
                    Retirement Savings Account, National Identity Number, NIN or
                    Company ID card) or by one or more factors specific to his
                    or her physical, ethnic or social identity. Data subjects
                    includes Leadway PFA’s Customers, NOKs of customers,
                    prospects and employees whose details are in the custody of
                    the company.
                  </li>

                  <li>
                    Data Administrator: means a persons or organization that
                    processes data. For the purpose of this policy, Leadway
                    PFA Limited is the Data Administrator.
                  </li>

                  <li>
                    Data Controller: means a person who either alone, jointly
                    with other persons or in common with other persons or as a
                    statutory body determines the purposes for and the manner in
                    which personal data is processed or is to be processed. For
                    the purpose of this policy, the Managing Director is the
                    Data Controller or whoever she/he so delegates.
                  </li>

                  <li>
                    Data Protection Officer: is appointed by the Data Controller
                    to ensure that the strategy and implementation of data
                    protection requirements are in compliance with the data
                    protection policy and the relevant extant laws. For the
                    purpose of this policy, the data protection officer is
                    defined as the Compliance officer.
                  </li>
                </ul>
                Responsibilities of the Data Administrator, Data Controller and
                Data Protection Officer are clearly outlined in the Nigeria Data
                Protection Regulation (2019).
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                INTRODUCTION
              </h4>

              <p className="grey-p-privacy">
                When LPPFA collects and processes the personal information of
                her data subjects, she ensures it adheres to strict controls to
                ensure that personal data of the data subject is obtained and
                used in line with the company’s privacy principles. LPPFA
                handles personal data with a duty of care and use it only for
                legitimate and specified business purposes within the Pension
                Industry under the following principles:
                <ol className="grey-p-privacy">
                  <li>
                    LPPFA respects the privacy rights of its employees,
                    Customers and other stakeholders, whose personal data are in
                    its custody and use.{" "}
                  </li>

                  <li>
                    LPPFA protects personal data by implementing appropriate
                    technical and organizational measures in our data processing
                    operations.{" "}
                  </li>

                  <li>
                    LPPFA holds itself accountable for demonstrating compliance
                    with applicable legal and regulatory requirements.{" "}
                  </li>
                </ol>
                All personal information collected by LPPFA is processed in
                accordance with the extant data protection laws in Nigeria.{" "}
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                {" "}
                Type of Information Processed by Leadway PFA Ltd.{" "}
              </h4>

              <p className="grey-p-privacy">
                The precise nature of the personal data LPPFA collected or
                processed depends on the nature of the transaction or the data
                subject’s relationship with LPPFA. However, if the Company is
                handling the data subject’s personal data as part of its role as
                a Pension Fund Administrator, the Company shall process in
                accordance to the following:
                <ol className="grey-p-privacy privacy-setting">
                  <li>
                    2.1. Information about the data subject – for example name,
                    age, gender, date of birth, nationality etc. as required by
                    Regulatory dictates or necessary for optimum service
                    delivery may be collected.
                  </li>
                  <li>
                    2.2. Means of identification – National Identity Card Number
                    (NIN), International Passport details, Drivers’ License,
                    Voter’s card details, etc. may be collected.
                  </li>
                  <li>
                    2.3. Contact information – in most cases, the Company may
                    receive the data subject’s email, address, and phone number.
                  </li>
                  <li>
                    2.4. Online information – for example cookies and IP address
                    (your computer’s internet address), if the data subject uses
                    LPPFA’s websites.
                  </li>
                  <li>
                    2.5. Financial information – the Company may process
                    information related to payments the data subject make or
                    receive in the context of Pension Contributions.
                  </li>
                  <li>
                    2.6. Other sensitive personal data (official designation
                    information, marital status, Biometric details, Gender etc.)
                  </li>
                  <p className="grey-p-privacy"> Requirement for Consent </p>
                  <li>
                    3.1. Where data subjects’ personal information is to be
                    collected, LPPFA shall explain the reason for obtaining the
                    data subject’s data, and obtain his consent for such use.
                    Without such consent, LPPFA may be unable to provide the
                    required services when the need arises. Where data subject
                    provides personal information about third parties, LPPFA may
                    ask such clients to confirm that the third parties have
                    given consent to the data subject to act on their behalf and
                    may be asked to provide LPPFA with a copy of the consent
                    issued.
                  </li>
                  <li>
                    3.2. Consent will be obtained via the same medium used to
                    obtain personal information or through any other means that
                    is acceptable to LPPFA. Reference will be made to this
                    Policy or a summarized version that can be easily understood
                    by the data subject. The data subject will be required to
                    indicate understanding and acceptance of the terms contained
                    in the policy. This can be via signature for physical
                    documents or a ticked checkbox for electronic platforms.
                  </li>
                  <li>
                    3.3. Where LPPFA has appropriate, legitimate business need
                    to use client personal information for maintenance of
                    business records including development and improvement of
                    products and services, LPPFA will take extra care to ensure
                    that the data subject’s rights to security and
                    confidentiality is not infringed upon.
                  </li>

                  <p className="grey-p-privacy">
                    {" "}
                    Reasons for use and process of data by Leadway PFA
                    Ltd.{" "}
                  </p>

                  <li>
                    4.1. LPPFA will obtain the consent of the data subject
                    before use and processing of the data for one or more
                    specific purposes made known to the data subject.
                  </li>
                  <li>
                    4.2. Such personal data obtained with the consent of the
                    data subject shall not be used in any manner other than the
                    stated purpose for which the data was obtained, except with
                    further consent of the data subject whether at the instance
                    of the data subject or upon LPPFA’s engagement with the data
                    subject.
                  </li>
                  <li>
                    4.3. LPPFA may use data subject’s personal data for a number
                    of reasons:
                  </li>
                  <li>
                    4.3.1. Maintenance of the data subject’s records with the
                    data administrator in order to provide contracted services
                  </li>
                  <li>4.3.2. Benefit Processing for Pension Payment</li>
                  <li>4.3.3. Training</li>

                  <li>
                    4.3.4. Assessing, improving and developing her products and
                    services
                  </li>
                  <li>
                    4.3.5. Enhancing our knowledge of risk and the pension
                    industry
                  </li>
                  <li>
                    4.3.6. Fulfilling legal or regulatory obligations and
                    protecting the Company and her customers against fraud.
                  </li>

                  <li>
                    4.3.7. For the protection of public interest such as
                    investigation of fraudulent claims and anti-money laundering
                    checks.
                  </li>

                  <li>
                    4.3.8. For archiving purposes in the public interest,
                    scientific or historical research purposes or statistical
                    purposes.
                  </li>
                  <li>
                    4.3.9. For the purpose of assessment of proposed data
                    subject’s employability and other employee benefits-related
                    purposes.
                  </li>
                  <li>
                    4.4. LPPFA applies information protection technologies
                    including access controls, perimeter security, malware
                    management, data loss prevention, backup and recovery.
                    LPPFA’s data centers are also protected against
                    environmental threats. LPPFA’s information security policies
                    and practices apply to all personal information in the
                    Company’s custody.
                  </li>
                  <li>
                    4.5. LPPFA will only transfer personal information to a
                    third party where the company has ensured that such
                    information is protected and the data subject’s consent has
                    been obtained. LPPFA will procure the privacy policy of the
                    Third Party (PFC, service providers) who may have access to
                    the information to guarantee the safeguard and protection of
                    the personal data of the data subject in the custody of the
                    third party. No consent shall be sought, given or accepted
                    in any circumstance that may engender direct or indirect
                    propagation of atrocities, hate, child abuse, human rights
                    violation, criminal acts and anti-social conducts.
                  </li>
                </ol>
                All personal information collected by LPPFA is processed in
                accordance with the extant data protection laws in Nigeria.{" "}
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                HOW LONG DO WE KEEP CUSTOMERS' INFORMATION ?
              </h4>

              <p className="grey-p-privacy">
                We shall hold Customers’ personal information on our systems
                for: (i) as long as is necessary for the relevant activity or
                services; (ii) any retention period that is established by
                National Pension Commission (PenCom). Available remedies in the
                event of violation of the privacy policy Where Data Subject is
                disgruntled with the way LPPFA has handled his/her personal
                information or any privacy query or request that have been
                raised with the Company, the data subject reserves the right to
                complain to the data protection authority (National Information
                Technology Development Agency (NITDA)). Third party data
                processing contracts LPPFA shall ensure that data processing of
                Customers’ personal data by a third party is in adherence to the
                dictates of the National Data Protection Regulation (NDPR) and
                that the third party is an NDPR compliant organization. Review
                of this privacy statement LPPFA may modify a part or the whole
                of this privacy statement from time to time. When changes are
                made to this privacy notice, the Company will revise the “last
                updated” date at the top of this privacy notice. The new
                modified or amended privacy statement will apply from that
                revision date.
              </p>

              <p className="grey-p-privacy">
                For further enquiries, please contact us on:
                <br />
                <span className="orangeText"> +234-1-2800850 </span> ext. 8051{" "}
                <br />
                Or send an email to{" "}
                <span className="orangeText"> dpo@leadway-pensure.com </span>
              </p>
            </div>
          )}
          {active === "Terms & Conditions" && (
            <div className="privacy-type-content">
              <h2 className="privacy-h2 ">Terms & Conditions</h2>
              <hr className="btm-bdr-rma mt-5 pb-5" />

              <h4 className="card-subtitle mb-2 privacy-hdr">
                LEADWAY PFA WEBSITE ACCESS AGREEMENT
              </h4>

              <p className="grey-p-privacy">
                Please read this Agreement carefully before accessing the
                Leadway PFA Website. As a condition to and in
                consideration of receiving and accessing the Leadway PFA
                Website, the User agrees to be bound by the terms of this
                Agreement. Use of or access to the Leadway PFA Website
                shall constitute acceptance of and agreement to be bound by this
                Agreement. If you do not wish to be bound by this agreement, do
                not access The Leadway PFA Website. If you have any
                questions about this Agreement, please contact us via e-mail at
                info@www.leadway-pensure.com THIS AGREEMENT “Agreement” is
                entered into by and between Leadway PFA and any
                individual, corporation, association, agency, company, or other
                entity who accesses or uses the Leadway PFA Website (the
                “User” or “you”). The Leadway PFA Website, which is
                provided without charge to you, is a World Wide Web site on the
                Internet that is designed to allow Leadway PFA to
                communicate with users and for you to interact with those users.
                The Leadway PFA Website is owned and operated by Leadway
                PFA. The Leadway PFA Website contains or may
                contain information, communications, opinions, text, graphics,
                links, electronic art, animations, audio, video, software,
                photos, music, sounds and other material and data (collectively,
                “Content”) formatted, organized and collected in a variety of
                forms that are generally accessible to Users, including
                directories and databases, and areas of the Leadway PFA
                Website that can be modified by Users, such as posting
                classifieds, uploading multimedia files, registering user
                profiles, and creating auto-notify, personalized pages, and
                personalized project areas.
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                {" "}
                USER RIGHTS AND RESPONSIBILITIES{" "}
              </h4>

              <p className="grey-p-privacy">
                Please read this Agreement carefully before accessing the
                Leadway PFA Website. As a condition to and in
                consideration of receiving and accessing the Leadway PFA
                Website, the User agrees to be bound by the terms of this
                Agreement. Use of or access to the Leadway PFA Website
                shall constitute acceptance of and agreement to be bound by this
                Agreement. If you do not wish to be bound by this agreement, do
                not access The Leadway PFA Website. If you have any
                questions about this Agreement, please contact us via e-mail at
                info@www.leadway-pensure.com THIS AGREEMENT “Agreement” is
                entered into by and between Leadway PFA and any
                individual, corporation, association, agency, company, or other
                entity who accesses or uses the Leadway PFA Website (the
                “User” or “you”). The Leadway PFA Website, which is
                provided without charge to you, is a World Wide Web site on the
                Internet that is designed to allow Leadway PFA to
                communicate with users and for you to interact with those users.
                The Leadway PFA Website is owned and operated by Leadway
                PFA. The Leadway PFA Website contains or may
                contain information, communications, opinions, text, graphics,
                links, electronic art, animations, audio, video, software,
                photos, music, sounds and other material and data (collectively,
                “Content”) formatted, organized and collected in a variety of
                forms that are generally accessible to Users, including
                directories and databases, and areas of the Leadway PFA
                Website that can be modified by Users, such as posting
                classifieds, uploading multimedia files, registering user
                profiles, and creating auto-notify, personalized pages, and
                personalized project areas.
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                {" "}
                USER CONDUCT{" "}
              </h4>

              <p className="grey-p-privacy">
                You agree to access and use the Leadway PFA Website only
                for lawful purposes. You are solely responsible for the
                knowledge of and adherence to any and all laws, statutes, rules
                and regulations, pertaining to
                <ol className="grey-p-privacy">
                  <li>
                    Your use of the Leadway PFA Website, including any
                    Interactive Area,
                  </li>
                  <li>
                    The use of any networks or other services connected to the
                    Leadway PFA Website,
                  </li>
                  <li>
                    The communications means by which you connect your modem,
                    computer, or other equipment to the Leadway PFA
                    Website. By accessing the Leadway PFA Website, you
                    agree that you will not:
                  </li>
                </ol>
                By accessing the Leadway PFA Website, you agree that you
                will not:
                <ul className="grey-p-privacy">
                  <li>
                    Restrict or inhibit any other user from using and enjoying
                    the Interactive Features;
                  </li>
                  <li>
                    Post or transmit any unlawful, threatening, abusive,
                    libelous, defamatory, obscene, vulgar, pornographic,
                    profane, or indecent information of any kind, including
                    without limitation any transmissions constituting or
                    encouraging conduct that would constitute a criminal
                    offence, give rise to civil liability or otherwise violate
                    any local, state, national, or international law;
                  </li>
                  <li>
                    Post or transmit any information, software, or other
                    material which violates or infringes in the rights of
                    others, including material which is an invasion of privacy
                    or publicity rights or which is protected by copyright,
                    trademark or other proprietary right, or derivative works
                    with respect thereto, without first obtaining permission
                    from the owner or right holder.
                  </li>

                  <li>
                    Post or transmit any information, software, or other
                    material which violates or infringes in the rights of
                    others, including material which is an invasion of privacy
                    or publicity rights or which is protected by copyright,
                    trademark or other proprietary right, or derivative works
                    with respect thereto, without first obtaining permission
                    from the owner or right holder.
                  </li>
                  <li>
                    Post or transmit any information, software or other material
                    which contains a virus or other harmful component;
                  </li>
                  <li>
                    Alter, damage or delete any Content or other communications
                    that are not your own Content or to otherwise interfere with
                    the ability of others to access the Leadway PFA
                    Website;
                  </li>
                  <li>
                    Disrupt the normal flow of communication in an Interactive
                    Area;
                  </li>
                  <li>
                    Claim a relationship with or to speak for any business,
                    association, institution or other organization for which you
                    are not authorized to claim such a relationship;
                  </li>
                  <li>
                    Violate any operating rule, policy or guideline of your
                    Internet access provider or online service.
                  </li>
                  <li>Intellectual Property Rights</li>
                </ul>
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                {" "}
                LEADWAY PFA WEBSITE CONTENT{" "}
              </h4>

              <p className="grey-p-privacy">
                You acknowledge that Content on the Leadway PFA Website
                is generally provided by Leadway PFA, individual
                contributors of Content (“Contributors”), third party licensees,
                and/or other Users. You acknowledge that the Leadway PFA
                Website permits access to Content that is protected by
                copyrights, trademarks, and other proprietary (including
                intellectual property) rights (“Intellectual Property Rights”),
                and that these Intellectual Property Rights are valid and
                protected in all media existing now or later developed and
                except as is explicitly provided below, your use of Content
                shall be governed by applicable copyright and other intellectual
                property laws. You acknowledge that the Leadway PFA
                Website owns a copyright in the “look and feel,” i.e., the
                selection, coordination, arrangement and presentation of such
                Content. You may not modify, copy, reproduce, transmit,
                distribute, publish, create derivative works from, display or
                otherwise transfer or commercially exploit any of the Content,
                in whole or in part, provided, however, that you may (i) make a
                reasonable number of digital or other form of copies to permit
                your computer hardware and software to access and view the
                Content, (ii) print one copy of each piece of Content, (iii)
                make and distribute a reasonable number of copies of Content, in
                whole or in part, in hard copy or electronic form for internal
                use only. Any permitted copies of Content must reproduce in an
                unmodified form any notices contained in the Content, such as
                all Intellectual Property Right notices, and an original source
                attribution to “The Leadway PFA Website” and its URL
                address. You acknowledge that the Leadway PFA Website,
                its Contributors, and/or Users remain the owners of the Content
                and that you do not acquire any Intellectual Property Rights by
                downloading or printing Content.
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                {" "}
                CONTENT PROVIDED BY USERS{" "}
              </h4>

              <p className="grey-p-privacy">
                You may upload to any Interactive Area or otherwise transmit,
                post, publish, reproduce or distribute, on or through the
                Leadway PFA Website only Content that is not subject to
                any Intellectual Property Rights, or Content in which any holder
                of Intellectual Property Rights has given express authorization
                for distribution over the Internet and on the Leadway
                PFA Website, without restriction whatsoever. Any Content
                submitted with the consent of a copyright owner other than you
                should contain a phrase such as “Copyright owned by [name of
                owner]; Used by Permission.” By submitting Content to any
                Interactive Area, you automatically grant and/or warrant that
                the owner of such Content, whether it be You or a third party,
                has expressly granted to Leadway PFA the royalty-free,
                perpetual, irrevocable, non-exclusive, unrestricted, worldwide
                right and license to use, reproduce, modify, adapt, publish,
                translate, create derivative works from, sublicense, distribute,
                perform, and display such Content, in whole or in part,
                worldwide and/or to incorporate it in other works in any form,
                media, or technology now known or later developed for the full
                term of any Intellectual Property Rights that may exist in such
                Content. You also permit Leadway PFA to sublicense to
                third parties the unrestricted right to exercise any of the
                foregoing rights granted with respect to such Content. You also
                permit any User to access, view, store and reproduce the Content
                for personal use.
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                {" "}
                INTERACTIVE AREAS{" "}
              </h4>

              <p className="grey-p-privacy">
                You may upload to any Interactive Area or otherwise transmit,
                post, publish, reproduce or distribute, on or through the
                Leadway PFA Website only Content that is not subject to
                any Intellectual Property Rights, or Content in which any holder
                of Intellectual Property Rights has given express authorization
                for distribution over the Internet and on the Leadway
                PFA Website, without restriction whatsoever. Any Content
                submitted with the consent of a copyright owner other than you
                should contain a phrase such as “Copyright owned by [name of
                owner]; Used by Permission.” By submitting Content to any
                Interactive Area, you automatically grant and/or warrant that
                the owner of such Content, whether it be You or a third party,
                has expressly granted to Leadway PFA the royalty-free,
                perpetual, irrevocable, non-exclusive, unrestricted, worldwide
                right and license to use, reproduce, modify, adapt, publish,
                translate, create derivative works from, sublicense, distribute,
                perform, and display such Content, in whole or in part,
                worldwide and/or to incorporate it in other works in any form,
                media, or technology now known or later developed for the full
                term of any Intellectual Property Rights that may exist in such
                Content. You also permit Leadway PFA to sublicense to
                third parties the unrestricted right to exercise any of the
                foregoing rights granted with respect to such Content. You also
                permit any User to access, view, store and reproduce the Content
                for personal use.
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                {" "}
                TERMINATION{" "}
              </h4>

              <p className="grey-p-privacy">
                The only right with respect to dissatisfaction with any
                policies, guidelines, or practices of Leadway PFA in
                operating the Leadway PFA Website, or any change in
                Content, is for you to discontinue accessing the Leadway Pensure
                PFA Website. Leadway PFA may terminate or temporarily
                suspend your access to all or any part of the Leadway Pensure
                PFA Website, without notice, for conduct that Leadway Pensure
                PFA believes is a violation of this Agreement or any policies or
                guidelines posted by Leadway Pensure PFA, or for other conduct
                which Leadway PFA believes, in its sole discretion, is
                harmful to Leadway PFA or other Users. Leadway Pensure
                PFA may discontinue operating the Leadway PFA Website
                and terminate this Agreement without notice at any time for any
                reason in its sole discretion. In the event of termination, you
                are no longer authorized to access the Leadway Pensure PFA
                Website, including the Interactive Areas, and the restrictions
                imposed on you with respect to Content downloaded from the
                Leadway PFA Website, as well as the disclaimers and
                limitations of liabilities set forth in this agreement, shall
                survive. Links; Disclaimers of Warranties; Limitations of
                Liability Links You understand that except for Content, products
                or services expressly available at the Leadway Pensure PFA
                Website, neither Leadway Pensure PFA, its subsidiary and parent
                companies, or affiliates, or their respective directors,
                officers, employees, and agents controls, provides, or is
                responsible for any Content, goods or services available through
                sites on the Internet linked to or from the Leadway Pensure PFA
                Website. All such Content, goods and services are made
                accessible on the Internet by independent third parties and are
                not part of the Leadway PFA Website or controlled by
                Leadway Pensure PFA. Leadway PFA neither endorses nor is
                responsible for the accuracy, completeness, usefulness, quality
                or availability of any Content, goods or services available on
                any site linked to or from the Leadway PFA Website,
                which are the sole responsibility of such independent third
                parties, and your use thereof is solely at your own risk.
                Neither Leadway Pensure PFA, its subsidiary and parent
                companies, or affiliates, or their respective directors,
                officers, employees, and agents shall be held responsible or
                liable, directly or indirectly, for any loss or damage caused or
                alleged to have been caused by your use of or reliance on any
                Content, goods or services available on any site linked to or
                from the Leadway PFA Website or your inability to access
                the Internet or any site linked to or from the Leadway Pensure
                PFA Website.
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                {" "}
                DISCLAIMER OF WARRANTIES{" "}
              </h4>

              <p className="grey-p-privacy">
                Please use your best judgment in evaluating all information
                contained or opinions expressed on the Leadway Pensure PFA
                Website. It is the policy of Leadway PFA not to endorse
                or oppose any opinion expressed by a User or Content provided by
                a User, Contributor, or other independent party. You expressly
                agree that your use of the Leadway PFA Website is at
                your sole risk. neither Leadway PFA nor any of its
                subsidiary and parent companies, or affiliates, or their
                respective directors, officers, employees, agents, contractors,
                affiliates, licensors or other suppliers providing content,
                data, information or services warrants that the Leadway Pensure
                PFA Website or any internet site linked to or from the Leadway
                Pensure PFA Website will be uninterrupted or error free, that
                defects will be corrected, or that this site, including the
                interactive areas, or the server that makes it available are
                free of viruses or other harmful components. nor do any of them
                make any warranty as to the results that may be obtained from
                the use of the Leadway PFA website or any internet site
                linked to or from the Leadway PFA Website or as to the
                timeliness, sequence, accuracy, authority, completeness,
                usefulness, non-infringement, reliability, availability, or
                substance of any content, information, service, or transaction
                provided through the Leadway PFA Website or any site
                linked to or from the Leadway PFA Website. The Leadway
                Pensure PFA Website is provided on an “as is,” “as available”
                basis, without warranties of any kind, either express or
                implied, including, without limitation, those of merchantability
                and fitness for a particular purpose.
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                {" "}
                LIMITATION OF LIABILITY{" "}
              </h4>

              <p className="grey-p-privacy">
                Under no circumstances shall Leadway Pensure PFA, its subsidiary
                and parent companies, or affiliates, or their respective
                directors, officers, employees, agents, contractors, or
                licensors, be liable for any direct or incidental, special or
                consequential damages under or arising from this agreement, the
                Leadway PFA Website, or any Internet site linked to or
                from the Leadway PFA Website, whether for breach of
                contract, tortuous behavior, negligence, or under any other
                cause of action, including without limitation, any liability for
                damages caused or allegedly caused by any failure of
                performance, error, omission, interruption, electrical
                surge/damage/interference, deletion, defect, delay in operation
                or transmission, computer virus, communications line failure,
                breakdown of equipment, software error, infringement,
                unauthorized access to, or theft, destruction, alteration, or
                use of, records. under no circumstances shall Leadway Pensure
                PFA, its subsidiary and parent companies, or affiliates, or
                their respective directors, officers, employees, agents,
                contractors, or licensors, be liable to you or any other third
                party for any decision made or action taken by you in reliance
                on the content contained within the Leadway PFA Website
                or the content contained within any Internet site linked to or
                from the Leadway PFA Website. The content within the
                Leadway PFA Website and the content within Internet
                sites linked to or from the Leadway PFA Website may
                include technical or other inaccuracies or typographical errors.
                Changes are periodically added to the content herein; these
                changes will be incorporated in new versions of the Leadway
                Pensure PFA Website and specifically are included in this
                section agreement. Leadway PFA and its contributors may
                make improvements and/or changes in the content at any time and
                from time to time. You specifically acknowledge and agree that
                Leadway PFA is not liable for any defamatory, offensive,
                fraudulent, or otherwise illegal conduct of any user. If you are
                dissatisfied with any Leadway PFA Website site content,
                or with the access agreement of the Leadway PFA Website,
                in whole or in part, your sole and exclusive remedy is to
                discontinue using the Leadway PFA Website.
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                {" "}
                INDEMNITY{" "}
              </h4>

              <p className="grey-p-privacy">
                You agree to indemnify and hold Leadway Pensure PFA, its parent
                or subsidiary companies and their affiliates, and their
                respective directors, officers, employees, and agents from any
                and all liabilities, claims and expenses, including reasonable
                attorney’s fees, arising from breach of this Agreement, any
                other policy, your use or access of the Leadway Pensure PFA
                Website or any Internet site linked to or from the Leadway
                Pensure PFA Website, or in connection with the transmission of
                any Content on the Leadway PFA Website.
              </p>

              <h4 className="card-subtitle mb-2 privacy-hdr pt-5">
                {" "}
                MISCELLANEOUS{" "}
              </h4>

              <p className="grey-p-privacy">
                This Agreement comprises the entire agreement between Leadway
                Pensure PFA and you, and supersedes any prior agreements with
                respect to the subject matter herein. Leadway PFA may
                revise this Agreement or any other policy at any time and from
                time to time, and such revision shall be effective two (2) days
                upon posting notice of such revision prominently on the Leadway
                Pensure PFA Website. You agree to review this Agreement
                periodically to be aware of such revisions. If any such revision
                is unacceptable to you, you must discontinue accessing the
                Leadway PFA Website. Your continued accessing and use of
                the Leadway PFA Website following notice of any such
                revision shall conclusively be deemed acceptance of all such
                revisions. The provisions of Sections 1.2, 2.1, 2.2, 5.1, 5.2,
                5.3, 6 and 7 shall survive the termination or expiration of this
                Agreement. If any provision of this Agreement or any other
                policy be held invalid or unenforceable, that portion shall be
                construed in accordance with applicable law as nearly as
                possible to reflect the original intention of the parties and
                the remaining portions will continue in full force and effect.
                The failure of Leadway PFA to insist upon or enforce
                strict performance of any provision of this Agreement shall not
                be construed as a waiver of any provision or right. This
                Agreement shall be governed by the laws of the state or province
                of domicile of Leadway Pensure PFA, excluding its conflict of
                laws rules, and you and the Leadway PFA Website each
                submit to the exclusive jurisdiction of the courts of that state
                or province. This Agreement is personal to you and you may not
                assign your rights or obligations thereunder to anyone. All
                logos, brand names, products, trademarks and service marks
                appearing herein may be the trademarks or service marks of their
                respective owners. References to any trademark, service mark and
                links to or from the Leadway PFA Website have been done
                strictly for clarification and identification and does not
                constitute endorsement by Leadway PFA of the products,
                services or information offered by the owner of such trademark,
                service mark or link or endorsement of Leadway PFA by
                such trademark, service mark or link owner.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Privacy;
